import { Injectable } from "@angular/core";
import { environmentConfig } from "../constants/constants";

export type Environment = keyof typeof environmentConfig;

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private readonly currentEnvironment: Environment;

  constructor() {
    this.currentEnvironment = this.detectEnvironment();
  }

  private detectEnvironment(): Environment {
    const currentUrl = window.location.origin;

    return Object.entries(environmentConfig).find(([_, config]) =>
      config.domain.some(domain => currentUrl.includes(domain))
    )?.[0] as Environment || 'production'; // Fallback to production if no match
  }

  getCurrentEnvironment(): Environment {
    return this.currentEnvironment;
  }

  getPricingUrl(): string {
    return environmentConfig[this.currentEnvironment].pricingUrl;
  }
}
